import { Col, Modal, Row, Spin } from "antd";
import React, { useState, useEffect } from "react";
import MainLayout from "../components/Layout";
import SummaryCard from "../components/SummaryCard";
import DetailCard from "../components/DetailCard";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import {
  UserAddOutlined,
  InfoCircleOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import Typography from "../components/Typography";
import { COLORS } from "../constants/Colors";
import { useNavigate } from "react-router-dom";
import OrderModal from "../components/OrderModal";
import ShipmentDetailModal from "../components/ShipmentDetailModal";
import ShipmentPreviewModal from "../components/ShipmentPreviewModal";
import MarkerIcon from "../components/Icon/Marker";
import MoreInformationModal from "../components/MoreInformationModal";
import { store } from "../utils/redux/store";
import { instance } from "../components/AxiosClient";
import GetProfile from "../components/VariableStore";
import _, { orderBy } from "lodash";
import LoginPage from "../pages/Login";
import {
  errorNotification,
  successNotification,
} from "../components/Notification";
import { FormattedMessage, useIntl } from "react-intl";
import MyButton from "../components/Button";
import CardTopHome from "../components/home/CardTop";
import CardLeftHome from "../components/home/CardLeft";
import CardRightHome from "../components/home/CardRight";
import { getContractPaging, getOrdersListApi, getQueueListApi, getQueueuList } from "../controllers/home/CardHomeAPI";
import "../components/home/cartop.css";
import moment from "moment";
import CreateQueueModal from "../components/queue/modal/createQueue";

const Home = () => {
  const intl = useIntl();
  const isDesktop = useIsDesktop();
  const colSpan = isDesktop ? 12 : 12;
  const navigate = useNavigate();
  const [spin, setSpin] = useState(false);
  const [isOpenOrderModal, setIsOpenOrderModal] = useState(false);
  const [isOpenShipmentModal, setIsOpenShipmentModal] = useState(false);
  const [focusShipmentDetail, setFocusShipmentDetail] = useState();
  const [isOpenPreviewModal, setIsOpenPreviewModal] = useState(false);
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);
  const [isOpenInfoModal, setIsOpenInfoModal] = useState(false);
  const [shipmentBodyCancel, setShipmentBodyCancel] = useState([]);
  const [summary, setSummary] = useState();
  const parsLocal = JSON.parse(localStorage.getItem("persist:loop_store"));
  const customerData = JSON.parse(parsLocal.customerProfileReducer);
  const comCode = GetProfile("customerCode") || _.get(customerData, "comCode");
  const customerId =
    GetProfile("customerId") || _.get(customerData, "customerId");
  const states = store.getState();
  const Lang = localStorage.getItem("lang");
  const [queueList, setQueueList] = useState([]);
  const [queueTotal, setQueueTotal] = useState(0);
  const [searchTable, setSearchTable] = useState({})
  const [activeQueueList, setActiveQueueList] = useState([])
  //-------------------------------------------------------
  const [queueVisible, setQueueVisible] = useState(false);
  const [event, setEvent] = useState(false);
    const [itemCate, setitemCate] = useState([]);

  useEffect(() => {
    const getSummary = async () => {
      const body = {
        pageNumber: 1,
        limit: 1000,
        customerId: customerId,
        status: "",
        type: 'carLot',
        orderBy: _.get(searchTable, "field"),
        order: _.get(searchTable, "order"),
      };

      try {
        setSpin(true);
        // const response = await instance.get(
        //   `/v5/business-partner/manager/company/${comCode}/customer/${customerId}/dashboard-summary`
        // );
        const response = await getContractPaging(body);
        setQueueList(response.data.contractList);
        setQueueTotal(_.get(response, 'data.totalItem', 0));
        setSpin(false);
      } catch (error) {}
    };
    if (customerId && comCode) getSummary();
  }, [customerId, comCode, searchTable]);

  useEffect(() => {
    const getOrdersList = async () => {
      const body = {
        fromDate: undefined,
        toDate: undefined,
        pageNumber: 1,
        limit: 9999,
        // queueNumber: 'asc',
        orderBy: 'queueNumber',
        orderType: 'asc',
        createdBy: customerId,
        orderStatus: ['sorting', 'outfordelivery', 'ready','confirmed'],
        orderTypeCode: ['SELF-DO', 'TAS-DO']
      };

      try {
        const response = await getQueueListApi(body);
        const data = _.map(_.get(response, 'data.list'), (o) => {
          return {
            queueNo: o.queueNo, //"0012",
            status: Lang === 'TH' ? _.get(o, "statusMapView.txt.TH")  :_.get(o, "statusMapView.txt.EN"),
            statusColor: _.get(o, "statusMapView.color"),
            vanNo: o.serialNoCarlot + ' ' + o.assetNameCarlot, //"001 01-0001",
            parkNo: o.serialNoMarket, //"A0001",
            parkName: o.assetNameMarket ? o.assetNameMarket : '', // "แผงจอห์น",
            list: o.parcel, //"5",
            statusQueue: o.waitingTime  //"รอแล้ว 25 นาที",
          }
        })
        setActiveQueueList(data)
        console.log('getOrdersList response', response)
      } catch (error) {}
    }

    if (customerId) getOrdersList()
  }, [event])

  const handleClickCreateOrder = () => {
    // setIsOpenOrderModal(true);
  };

  const handleCloseOrderModal = () => {
    setIsOpenOrderModal(false);
  };

  const handleClosePreviewModal = () => {
    setIsOpenPreviewModal(false);
  };

  const handleCloseInfoModal = () => {
    setIsOpenInfoModal(false);
  };

  const handleClickSaveShipmentOrder = (info) => {
    //console.log('TestCloseModal3', shipmentBodyCancel);
    //console.log('TestCloseModal31', focusShipmentDetail);
    setFocusShipmentDetail(info);
    setIsOpenShipmentModal(true);
    setIsOpenOrderModal(false);
    setShipmentBodyCancel((e) => ({
      ...e,
      statusDetail: {
        sequence: 2,
        statusCode: "canceled",
        statusColor: "#898989",
        statusId: "63e215bad1d35a62710f5b0f",
        statusName: "Canceled",
        statusText: { EN: "Canceled", TH: "ยกเลิก" },
      },
    }));
  };

  const handleCloseShipmentDetail = () => {
    setIsOpenShipmentModal(false);
  };

  const handleClickPrint = () => {
    setIsOpenPreviewModal(true);
    // setIsOpenShipmentModal(false);
  };

  const handleClickCancelShipment = async () => {
    const comCode = GetProfile("customerCode");
    //console.log('Test Cancel');
    const id = _.get(focusShipmentDetail, "orderId");
    try {
      await instance.put(
        `/v5/order/manager/company/${comCode}/web/deliveryorder/loopmerchant/${id}`,
        shipmentBodyCancel
      );
      setIsOpenConfirmModal(false);
      setIsOpenShipmentModal(false);
      successNotification(
        intl.formatMessage({
          id: "deleteSuccessNotification",
          defaultMessage: "Success",
        })
      );
    } catch (error) {
      errorNotification(
        intl.formatMessage({
          id: "saveErrorNotification",
          defaultMessage: "Failed",
        })
      );
    }
  };

  const handleChangeTable = (pagination, sorter, extra) => {
    console.log("tablechange", pagination, "sorter:", sorter, "extra:", extra);
    let field = extra.field;
    if (extra.order) {
      if (extra.order === "descend") {
        setSearchTable((prev) => ({ ...prev, order: "desc" }));
      } else {
        setSearchTable((prev) => ({ ...prev, order: "asc" }));
      }
    } else {
      setSearchTable((prev) => ({ ...prev, order: undefined }));
    }

    setSearchTable((prev) => ({
      ...prev,
      field: field,
    }));
    // searchShipment.setShipmentField(field);
    // searchShipment.setShipmentPage(pagination.current);
    // searchShipment.setShipmentSize(pagination.pageSize);
  };

  const accessToken = states.authenReducer.accessToken;

  if (!accessToken) {
    return <LoginPage />;
  }
  const openCreateQueue = () => {
    setQueueVisible(true)
  }

  const closeCreateQueue = () => {
    setQueueVisible(false)
  }

  return (
    // <MainLayout isMainPage onCreateOrder={handleClickCreateOrder}>
    <div className="d-flex flex-column w-100 h-100 p-3 justify-content-between">
      <Spin spinning={spin}>
        {!isDesktop ? (
          <div>
            <div className="card-div-home-moblie-top">
              <CardTopHome queueList={queueList} queueTotal={queueTotal} type={"park"} />
            </div>

            <div className="card-div-home-moblie">
              <CardLeftHome queueList={queueList} setitemCate={setitemCate} />
            </div>
            <div className="card-div-home-moblie-top">
              <CardTopHome type={"queue"} menu={'home'}/>
            </div>
            <div className="card-div-home-moblie">
              <CardRightHome data={activeQueueList} openCreateQueue={openCreateQueue}/>
            </div>
          </div>
        ) : (
          <div>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <CardTopHome queueList={queueList} queueTotal={queueTotal} type={"park"} />
              </Col>
              <Col span={12}>
                <CardTopHome type={"queue"} menu={'home'} setitemCate={setitemCate}/>
              </Col>
              <Col span={colSpan}>
                <div style={{ cursor: "pointer" }}>
                  <CardLeftHome queueList={queueList} handleChange={handleChangeTable}/>
                </div>
              </Col>
              <Col span={colSpan}>
                <div style={{ cursor: "pointer" }}>
                  <CardRightHome data={activeQueueList} openCreateQueue={openCreateQueue}/>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </Spin>
      {/* <Typography
        isBold
        className={`text-center w-100 ${isDesktop ? "pb-4" : "pb-1"} pt-3`}
        size={isDesktop ? "18px" : "14px"}
        color={COLORS.Gray}
      >
        <FormattedMessage
          id="textCustomerService"
          defaultMessage="Customer Service : 02-111-0099"
        />
      </Typography> */}
      {!isDesktop && (
        <div
          className={`d-flex align-items-center ${
            isDesktop ? "justify-content-start" : "justify-content-center"
          } px-4`}
          style={{
            height: 46,
            backgroundColor: COLORS.Primary,
            padding: "24px",
            width: "100vw",
            marginLeft: "-16px",
            marginTop: "16px",
          }}
        >
          <Typography size="12.5px" color={COLORS.White}>
            Powered by © RAPIDTECH Co., Ltd. (V 1.0)
          </Typography>
        </div>
      )}
      <Modal
        className="custom-modal"
        open={isOpenConfirmModal}
        onCancel={() => {
          setIsOpenConfirmModal(false);
        }}
        width={300}
        onOk={handleClickCancelShipment}
        centered={true}
        style={{ height: "auto" }}
        footer={[
          <div>
            <MyButton
              onClick={() => {
                setIsOpenConfirmModal(false);
              }}
              style={{
                width: isDesktop ? "30%" : "30%",
                marginLeft: "0px",
                marginTop: "8px",
              }}
            >
              <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
            </MyButton>{" "}
            <MyButton
              isPrimary
              onClick={handleClickCancelShipment}
              style={{
                width: isDesktop ? "30%" : "30%",
                marginInlineStart: "0px",
              }}
            >
              <FormattedMessage id="btnOK" defaultMessage="Ok" />
            </MyButton>
          </div>,
        ]}
      >
        <Typography
          isBold
          size="16px"
          color={COLORS.Primary}
          className="text-center p-2"
        >
          Cancel Shipment
        </Typography>
        <Typography className="text-center p-3 pb-4">
          Do you want to cancel shipment ?
        </Typography>
      </Modal>

      <CreateQueueModal isOpen={queueVisible} onCancle={closeCreateQueue} setTrigger={setEvent} itemCate={itemCate} />
      <OrderModal
        isOpen={isOpenOrderModal}
        onCancle={handleCloseOrderModal}
        onSave={handleClickSaveShipmentOrder}
        setShipmentBodyCancel={setShipmentBodyCancel}
      />
      <ShipmentDetailModal
        info={focusShipmentDetail}
        isOpen={isOpenShipmentModal}
        onCancle={handleCloseShipmentDetail}
        onClickPrint={handleClickPrint}
        onCancleShipment={() => {
          setIsOpenConfirmModal(true);
        }}
        isPreview
        setFocusShipmentDetail={setFocusShipmentDetail}
      />
      <ShipmentPreviewModal
        info={focusShipmentDetail}
        isOpen={isOpenPreviewModal}
        onCancle={handleClosePreviewModal}
        parcels={focusShipmentDetail?.parcels || []}
        totalParcel={focusShipmentDetail?.totalParcel || 0}
      />
      <MoreInformationModal
        isOpen={isOpenInfoModal}
        onCancle={handleCloseInfoModal}
      />
    </div>
    // </MainLayout>
  );
};

export default Home;
